import { render } from "./StoriesUpload.vue?vue&type=template&id=da2960b8"
import script from "./StoriesUpload.vue?vue&type=script&lang=js"
export * from "./StoriesUpload.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__